import { render, staticRenderFns } from "./ChromosomalDescriptions.vue?vue&type=template&id=2164583c&scoped=true"
import script from "./ChromosomalDescriptions.vue?vue&type=script&lang=js"
export * from "./ChromosomalDescriptions.vue?vue&type=script&lang=js"
import style0 from "../assets/main.css?vue&type=style&index=0&id=2164583c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2164583c",
  null
  
)

export default component.exports